module.exports = __webpack_public_path__ + "img/2.55fa7a68.png";